import { h3ToGeo } from "h3-js";

export class StreamData {
  /**
   * Data inside the event
   * @param {Object} streamvalue object
   * @param {String} streamvalue.column Column on which the event happened
   * @param {String} streamvalue.value Value of the column during the event
   */
  constructor({ column, value }) {
    this.column = column;
    this.value = value;
  }
}

export class Event {
  /**
   * Event happening on/by an entity
   * @param {Object} event
   * @param {String} event.timestamp Timestamp of the event
   * @param {Array[Number]} event.location Location of the event
   * @param {String} event.grid_id Grid id of the event
   * @param {Array[StreamData]} event.data List of data related to the event
   */
  constructor({ timestamp, location, grid_id, data }) {
    this.timestamp = new Date(timestamp);
    this.location = location;
    this.grid_id = grid_id;
    this.data = data.map(item => new StreamData(item));
    // if no location is present, get the location from the grid_id
    if (!location && grid_id) {
      this.location = h3ToGeo(grid_id);
    }
  }
}

export default class Overview {
  /**
   * All the data needed for the overview of an entity
   * @param {Object} OverviewData
   * @param {String} OverviewData.entity_id EntityId of the item
   * @param {String} OverviewData.entity_name Name of the base entity
   * @param {String} OverviewData.entity_item_id Item id of the current entity
   * @param {String} OverviewData.total_events Total events of the entity
   * @param {Array[Event]} OverviewData.event_stream Array of events
   */
  constructor({
    entity_id,
    entity_name,
    entity_item_id,
    total_events,
    last_seen,
    first_seen,
    event_stream,
    event_summary,
    total_pages,
    current_page,
  }) {
    this.entity_id = entity_id;
    this.entity_name = entity_name;
    this.entity_item_id = entity_item_id;
    this.total_events = total_events;
    this.last_seen = last_seen ? new Date(last_seen) : "No data";
    this.first_seen = first_seen ? new Date(first_seen) : "No data";
    this.event_stream = event_stream.map(item => new Event(item));
    this.event_summary = event_summary;
    this.total_pages = total_pages;
    this.current_page = current_page;
  }
}
